<div
  *transloco="let t; read: 'project-icon-selector'"
  class="xi-modal__container project-icon-selector__container"
>
  <h2 class="xi-modal__title">{{ t('title') }}</h2>

  <div class="xi-modal__content">
    <div class="project-icon-container">
      <img src="{{ getSelectedUrl() }}" />
    </div>

    @if (projectIconList.length > 0) {
      <div class="project-images-container">
        @for (icon of projectIconList; track icon; let i = $index) {
          <img
            (click)="updateSelectedUrl(icon)"
            src="{{ getProjectIcon(icon) }}"
            [class.selected]="selectedUrl === icon"
          />
        }
      </div>
    }
  </div>

  <div class="xi-modal__actions project-icon-selector__actions">
    <xi-default-button [text]="t('cancel')" fill="text" (onClick)="cancel()"></xi-default-button>

    <xi-default-button [text]="t('confirm')" (onClick)="select()"></xi-default-button>
  </div>
</div>
